import requestFunctions from "../../functions/requestFunctions";


export const state = {
  REGIONS_ITEM: {},
  REGIONS_LIST: [],
  REGIONS_TABLE_DATA: [],
  REGIONS_LIST_DATA: [],
  REGIONS_TOTAL_ROWS: 0
}

export const getters = {
  GET_REGIONS_ITEM: (state) => {
    return state.REGIONS_ITEM;
  },
  GET_REGIONS_LIST_DATA: (state) => {
    return state.REGIONS_LIST_DATA;
  },
  GET_REGIONS_TABLE_DATA: (state) => {
    return state.REGIONS_TABLE_DATA;
  },
  GET_REGIONS_TOTAL_ROWS: (state) => {
    return state.REGIONS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_REGIONS_ITEM(state, item) {
    state.REGIONS_ITEM = item;
  },
  UPDATE_REGIONS_LIST(state, list) {

    state.REGIONS_LIST = list.data;
    state.REGIONS_TOTAL_ROWS = list.total;

    list = list.data;

    state.REGIONS_TABLE_DATA = [];
    state.REGIONS_LIST_DATA = [];

    list.forEach(el => {

      state.REGIONS_TABLE_DATA.push({
        'id'   : el.id ? el.id : null,
        'uuid' : el.uuid ? el.uuid : null,
        'country_name': el.country_name ? el.country_name : null,
        'name': el.name ? el.name : null,
        'utc': el.utc ? el.utc : null,

      });

      state.REGIONS_LIST_DATA.push({
        'id'   : el.id   ? el.id   : null,
        'uuid' : el.uuid ? el.uuid : null,
        'country_name': el.country_name ? el.country_name : null,
        'name': el.name ? el.name : null,
        'utc': el.utc ? el.utc : null,

      });

    });
  },
}


export const actions = {

  async FETCH_REGIONS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/regions/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_REGIONS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_REGIONS_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/regions';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_REGIONS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_REGIONS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/regions';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_REGIONS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/regions/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_REGIONS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/regions/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}